import { render } from "./ApiStatusCard.vue?vue&type=template&id=b0f90434"
import script from "./ApiStatusCard.vue?vue&type=script&lang=js"
export * from "./ApiStatusCard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__